
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { marked } from 'marked';
import { gfmHeadingId } from 'marked-gfm-heading-id';
import customHeadingId from 'marked-custom-heading-id';

marked.use({
    headerIds: true,
    mangle: false
});
marked.use(gfmHeadingId());
marked.use(customHeadingId());

let articleName = '';

const renderer = {
    image(href, title, text) {
        const params = encodeURIComponent(`{"article":"${articleName}","img":"${href}"}`);
        href = `/service/portal/GetArticleImg?params=${params}`;
        return `<img src="${href}" title="${title || text}" />`;
    },
    link(href, title, text) {
        // ToDo: added support for `target` attribute
        return false;
    }
}
marked.use({renderer});

const classNames = mergeStyleSets({
    Article: {
        paddingTop: 8,
        paddingBottom: 8,
    },
    title: {
        fontSize: '18px',
        fontWeight: 'bold'
    },
    abstract: {
        paddingTop: 8,
        fontSize: '14px',
        fontWeight: 'bold',
        textAlign: 'justify'
    },
    text: {
        paddingTop: 8,
        fontSize: '14px',
        fontWeight: 'normal',
        textAlign: 'justify'
    }
});

const Article = ({article}) => {
    articleName = article.name;
    return (
        <Stack className={classNames.Article} tokens={{childrenGap: 8}}>
            <Stack.Item className={classNames.title}>
                {article.title}
            </Stack.Item>
            <Stack.Item className={classNames.abstract}>
                {article.abstract}
            </Stack.Item>
            <Stack.Item className={classNames.text}>
                <div dangerouslySetInnerHTML={{__html: marked.parse(article.text)}} />
            </Stack.Item>
        </Stack>
    );
}

export default Article;
